import { rem } from 'polished';
import Header from '../Header';
import React from 'react';
import styled, { css } from 'styled-components';
const Wrapper = styled.div `
  display: flex;
  align-items: center;
  ${({ $active }) => $active &&
    css `
      margin-bottom: ${rem(16)};
    `}
`;
const StyledHeader = styled(Header) `
  font-weight: normal;
  ${({ $active }) => $active &&
    css `
      font-weight: 500;
    `}
`;
const RadioBorder = styled.div `
  flex-shrink: 0;
  display: flex;
  align-items: center;
  justify-content: center;
  width: ${rem(24)};
  height: ${rem(24)};
  box-shadow: 0px 1px 2px rgba(0, 0, 0, 0.08);
  border-radius: 50%;
  border: 1px solid ${({ theme }) => theme.form.placeholderColor};
  ${({ $active }) => $active &&
    css `
      border: 2px solid ${({ theme }) => theme.color.primary};
    `}
  transition: border 250ms;
  margin-right: ${rem(8)};
`;
const RadioFill = styled.div `
  width: ${rem(14)};
  height: ${rem(14)};
  background-color: ${({ theme }) => theme.color.primary};
  border-radius: 50%;
  opacity: 0;
  ${({ $active }) => $active &&
    css `
      opacity: 1;
    `}

  transition: opacity 250ms;
`;
const DomainHeader = ({ children, active }) => {
    return (React.createElement(Wrapper, { "$active": active },
        React.createElement(RadioBorder, { "$active": active },
            React.createElement(RadioFill, { "$active": active })),
        React.createElement(StyledHeader, { "$active": active, size: "s", noBottomGutter: true }, children)));
};
export default DomainHeader;
